<template>
  <section @contextmenu="handleMouse" class="HLSPlay-component">
    <video-player
      :options="playerOptions"
      :playsinline="true"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @ended="onPlayerEnded($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @pause="onPlayerPause($event)"
      @play="onPlayerPlay($event)"
      @playing="onPlayerPlaying($event)"
      @ready="playerReadied"
      @statechanged="playerStateChanged($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @waiting="onPlayerWaiting($event)"
      class="video-player-box"
      controlslist=“nodownload”
      ref="videoPlayer"
    >
    </video-player>
    <video ref="canvideo" style="display: none;width: 100%;height: 100%;"></video>
    <canvas ref="canvas" style="display: none;"></canvas>
  </section>
</template>
<script>
  import 'video.js/dist/video-js.css'
  import 'videojs-contrib-hls'
  import {videoPlayer} from 'vue-video-player'
  //   import videoPlayer from '@videojs-player/vue'

  export default {
    name: 'HLSPlay',
    props: {
      src: {
        type: String
      },
      cover_url: {
        type: String
      }
    },
    components: {
      videoPlayer
    },
    data() {
      return {
        // [配置信息](https://blog.csdn.net/qq_39905409/article/details/98481735)
        playerOptions: {
          // videojs options
          autoplay: false,
          muted: false,
          preload: 'auto',
          language: 'zh-CN',
          fluid: true,
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          customEventName: false,
          sources: [
            {
              // type: "video/webm",
              // type: "video/ogg",
              // type: "video/3gp",
              type: 'video/mp4',
              // type: 'application/x-mpegURL',
              src: this.src, // 路径
              // src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm'
            }
          ],
          // poster: 'https://t7.baidu.com/it/u=602106375,407124525&fm=193&f=GIF',
          poster: this.cover_url, // 你的封面地址
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true, // 全屏按钮
            currentTimeDisplay: true, // 当前时间
            volumeControl: false, // 声音控制键
            playToggle: true, // 暂停和播放键
            progressControl: true // 进度条
          }
        }
      }
    },
    mounted() {
      this.init(this.src)
      // console.log('this is current player instance object', this.player)
    },
    computed: {
      player() {
        return this.$refs.videoPlayer.player
      }
    },
    methods: {
      handleMouse(e) {
        console.log(e);
        e.preventDefault();
      },
      setSrc(src) {
        // 重新设置播放地址
        this.init(src)
        this.playerOptions['sources'][0]['src'] = src;
        setTimeout(() => {
          this.$refs.videoPlayer.player.play() // 播放
        }, 1000)
      },
      play() {
        // 手动触发播放
        this.$refs.videoPlayer.player.play() // 播放
      },
      init(src) {
        const video = this.$refs.canvideo
        video.src = src
        var canva = this.$refs.canvas
        const ctx = canva.getContext("2d") // 绘制2d
        video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
        video.currentTime = 1; // 第一帧
        video.oncanplay = () => {
          canva.width = this.$refs.videoPlayer.$el.clientWidth; // 获取视频宽度
          canva.height = this.$refs.videoPlayer.$el.clientHeight; //获取视频高度
          // 利用canvas对象方法绘图
          ctx.drawImage(video, 0, 0, this.$refs.videoPlayer.$el.clientWidth, this.$refs.videoPlayer.$el.clientHeight);
          this.playerOptions['poster'] = canva.toDataURL("image/png");
          // this.cover_url = canva.toDataURL("image/png");

        };
        setTimeout(() => {
          var div = this.$refs.videoPlayer.$el
          var div1 = div.firstChild
          var div3 = document.createElement("img");
          div3.id = 'userName';
          div3.setAttribute("class", "resize-drag");
          // 从父组件传过来的水印内容

          div3.src = require('../../assets/image/resource/17420d42ce1210895dad41d52414d37.png')
          div3.style.cssText = "position:absolute;top:10px;left:10px;pointer-events:none;opacity:0.5";
          div1.appendChild(div3)
        }, 1000);
      },
      // listen event
      onPlayerPlay(player) {
        console.log('player play!', player)
      },
      onPlayerPause(player) {
        console.log('player pause!', player)
      },
      onPlayerEnded(player) {
        console.log('player onPlayerEnded!', player)
      },
      onPlayerWaiting(player) {
        console.log('player onPlayerWaiting!', player)
      },
      onPlayerPlaying(player) {
        console.log('player onPlayerPlaying!', player)
      },
      onPlayerLoadeddata(player) {
        console.log('player onPlayerLoadeddata!', player)
      },
      onPlayerTimeupdate(player) {
        console.log('player onPlayerTimeupdate!', player)
      },
      onPlayerCanplay(player) {
        console.log('player onPlayerCanplay!', player)
      },
      onPlayerCanplaythrough(player) {
        console.log('player onPlayerCanplaythrough!', player)
      },
      // ...player event

      // or listen state event
      playerStateChanged(playerCurrentState) {
        console.log('player current update state', playerCurrentState)
      },

      // player is ready
      playerReadied(player) {
        console.log('the player is readied', player)
        // you can use it to do something...
        // player.[methods]
      }
    }

  }
</script>
<style lang="less" scoped>
  /deep/ .video-player {
    // 设置 fluid: true，宽高自适应
    // 默认  1024 * 576
    // .vjs_video_3-dimensions {
    //   width: 1024px;
    //   height: 576px;
    // }

    // 初始化，暂停按钮居中
    .vjs-big-play-button {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>

